import { ExpansionContextProvider } from 'utils/contexts/expansion';
import { Table } from './Table';
import { AudienceCountsTableSkeleton } from './AudienceCountsTableSkeleton';
import { EmptyData } from '../EmptyData';
import { AudienceCount } from '../../domain';

type AudienceCountsProps = {
  values: AudienceCount[];
  hasChart?: boolean;
  isLoading?: boolean;
};

export const AudienceCountsTable = ({
  values,
  isLoading = false,
  hasChart = false,
}: AudienceCountsProps) => {
  if (isLoading) return <AudienceCountsTableSkeleton />;

  return values.length > 0 ? (
    <ExpansionContextProvider>
      <Table values={values} hasChart={hasChart} />
    </ExpansionContextProvider>
  ) : (
    <EmptyData />
  );
};
